// Synced from Figma: MarketView Design System → Color palette
// https://www.figma.com/design/9RCnxMalOaIKmeEhfwCwz2/branch/22p2pJNxDa1FMcXOFXZYqp/%F0%9F%93%8A-MarketView-Design-System?node-id=23308-695&m=dev
export const colors = {
  white: '#FFFFFF',
  lime: {
    50: '#F8FFE3',
    100: '#EDFFB8',
    200: '#DDF88B',
    300: '#CCEE63',
    400: '#B6DE3A',
    500: '#98C804',
    600: '#8BB800',
    700: '#739900',
    800: '#618001',
    900: '#455B01',
    950: '#303D0A',
  },
  blue: {
    50: '#F0FBFF',
    100: '#E6F9FF',
    200: '#CCF1FF',
    300: '#99E3FF',
    400: '#66D4FF',
    500: '#2CC1F2',
    600: '#0BA1D8',
    700: '#007AAB',
    800: '#005B80',
    900: '#003F5C',
    950: '#002D42',
  },
  navy: {
    50: '#F5F8FA',
    100: '#E1E7EF',
    200: '#C0CBD8',
    300: '#8EA4BE',
    400: '#6D8AAB',
    500: '#506D95',
    600: '#315381',
    700: '#184072',
    800: '#002D5D',
    900: '#00254C',
    950: '#001933',
  },
  gray: {
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#111827',
    950: '#030712',
  },
  amber: {
    50: '#FFFBEB',
    100: '#FEF3C7',
    200: '#FDE68A',
    300: '#FCD34D',
    400: '#FBBF24',
    500: '#F59E0B',
    600: '#D97706',
    700: '#B45309',
    800: '#92400E',
    900: '#78350F',
    950: '#451A03',
  },
  critical: {
    50: '#FDECF2',
    100: '#FBD5E1',
    200: '#FFBDD2',
    300: '#F282A6',
    400: '#EF5D8B',
    500: '#EA336D',
    600: '#D91655',
    700: '#B30039',
    800: '#6B0B29',
    900: '#380615',
    950: '#1C030B',
  },
  success: {
    50: '#F5FDF0',
    100: '#E9FCDC',
    200: '#D3F7BB',
    300: '#ADEF86',
    400: '#80DE4A',
    500: '#5EC522',
    600: '#4AA316',
    700: '#3C8015',
    800: '#306516',
    900: '#214A12',
    950: '#0D2904',
  },
};

export const shadows = {
  xsmall: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
  small: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
  medium: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
  large: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
} as const;

export const spacing = {
  chartFramePx: 16,
} as const;

export const fontFamilies = {
  sans: [
    'Barlow, IBM Plex Sans',
    'ui-sans-serif',
    'system-ui',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
    '"Noto Color Emoji"',
  ],
} as const;

// Responsive breakpoints (px). Single source of truth for both Tailwind
// `screens` (tailwind.config.js) and viewport-based logic in TS.
export const breakpoints = {
  mobile: 375,
  tablet: 780,
  xs: 960,
  sm: 1024,
  md: 1280,
  lg: 1440,
  xl: 1600,
} as const;
